import React from 'react';

import type { useFloatingSetup } from './useFloatingSetup';

type ContextType = ReturnType<typeof useFloatingSetup> | null;

export const FloatingContext = React.createContext<ContextType>(null);

export const useFloatingContext = () => {
    const context = React.useContext(FloatingContext);

    if (context == null) {
        throw new Error('Floating components must be wrapped in <FloatingContext />');
    }

    return context;
};
